var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Trans, useTranslation } from "react-i18next";
import { Tooltip, message } from "antd";
import Icon, { LinkOutlined } from "@ant-design/icons";
import classNames from "classnames";
import { Permissions } from "@whatsper/texterchat-common";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerListView } from "../core";
import { getAxios } from "../../../../backend";
import { API_PATH } from "../../../../constants";
import { getDirection } from "../../../../helpers";
import styles from "./ApiTokensListView.module.scss";
import entityManagerStyles from "../../../EntityManager/EntityManager.module.scss";
const TokenTeaser = ({ entity }) => {
    return (React.createElement("div", { className: styles.teaserContainer },
        React.createElement("h4", { className: styles.teaserTitle }, entity.title)));
};
const ApiTokensListView = ({ onEntitySelect, onEntityDelete, searchQuery = "", refreshList }) => {
    const { agentsStore } = useStore();
    const { t } = useTranslation();
    const [tokens, setTokens] = useState([]);
    const [loading, setLoading] = useState(false);
    const apiTokensSearchQuery = searchQuery.trim().toLowerCase();
    useEffect(() => {
        loadTokens();
    }, []);
    useEffect(() => {
        refreshList === null || refreshList === void 0 ? void 0 : refreshList(loadTokens);
    }, [refreshList]);
    const loadTokens = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const axios = yield getAxios();
            const { data } = yield axios.get(API_PATH.API_TOKENS);
            setTokens(data);
        }
        catch (error) {
            console.error("Failed to load tokens:", error);
        }
        finally {
            setLoading(false);
        }
    });
    const getOpSupported = () => {
        const { hasPermissions } = agentsStore;
        const ops = [];
        if (hasPermissions([Permissions.Permission.api_tokens_view])) {
            ops.push(Operation.LIST);
        }
        if (hasPermissions([Permissions.Permission.api_tokens_manage])) {
            ops.push(Operation.CREATE, Operation.EDIT);
        }
        return ops;
    };
    const filteredTokens = tokens.filter((token) => {
        var _a;
        if (!apiTokensSearchQuery)
            return true;
        const title = ((_a = token.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
        return title.includes(apiTokensSearchQuery);
    });
    const customListActions = (token) => {
        const onClick = (e) => {
            e.stopPropagation();
            if (window.isSecureContext) {
                navigator.clipboard.writeText(token.token);
                message.success(t("apiTokenCopiedToClipboard"));
            }
            else {
                message.error(t("clipboardNotSupported"));
            }
        };
        return (React.createElement(Tooltip, { title: t("copyAPIToken") },
            React.createElement(Icon, { className: classNames(styles.copyIconBtn, entityManagerStyles.entityListItemBtn, {
                    [entityManagerStyles.rtl]: getDirection() === "rtl",
                }), component: LinkOutlined, onClick: onClick })));
    };
    return (React.createElement(ManagerListView, { entities: filteredTokens, entityIdKey: "_id", teaser: TokenTeaser, loading: loading, opSupported: getOpSupported(), onEntitySelect: onEntitySelect, onEntityDelete: onEntityDelete, createTitle: React.createElement(Trans, { i18nKey: "addToken" }), customListActions: customListActions }));
};
export default observer(ApiTokensListView);
